import { useEffect, useState } from "react";
import appLabel from "../../config/appLabel";
import { BOM } from "../../services/defined.action";
import { cnt } from "../../services/constant.action";
import { apis as api } from "../../services/api.action";
import { Tooltips } from "../layouts/Facility";
import appStatic from "../../config/appStaticData";
import { useForm } from "react-hook-form";

const OtherContacts = ({ data = [], isEdit = true, userData = {} }) => {
  const { profileId, session } = userData;
  const companyId = data[0]?.COMPANY_ID;
  const [isShowingInfoEntry, setIsShowingInfoEntry] = useState(false);
  const [editedData, setEditedData] = useState();
  const addHandler = () => {
    setIsShowingInfoEntry(true);
    setEditedData(undefined);
  };
  const editHandler = (data) => {
    setEditedData(data);
    setIsShowingInfoEntry(true);
  };
  const disableHandler = async (data) => {
    BOM.LoadAlert(cnt.LOAD, "Processing");
    let body = {
      profileId,
      session,
      criteria: data.FLG_STATUS === "A" ? "U" : "A",
      userId: data.USERID,
    };
    BOM.FetchReqAction(body, api.ApproveRejectUser, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, res.message);
      }
    });
  };

  return (
    <section className="col-sm-12">
      <header
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <label className="al-heading">
          <i className="fa fa-circle-o text-navy"></i>
          &nbsp; {appLabel.otherContacts}
        </label>

        {isEdit && (
          <button
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
            }}
            onClick={addHandler}
            className="btn btn-primary btn-md"
            type="button"
          >
            <i className="fa fa-plus-circle" />
            <span> {appLabel.addContact}</span>
          </button>
        )}
      </header>
      <div className="hr-line-dashed" style={{ marginTop: 0 }} />
      <main
        style={{
          width: "100%",
          display: "flex",
          gap: 16,
          flexDirection: "column",
        }}
      >
        {isShowingInfoEntry && (
          <AddOrEditContact
            data={editedData}
            userData={userData}
            onSuccess={(newOrUpdatedData) => {
              setEditedData(undefined);
              setIsShowingInfoEntry(false);
            }}
            onCancel={() => {
              setEditedData(undefined);
              setIsShowingInfoEntry(false);
            }}
            contactCompanyId={companyId}
          />
        )}
        <ul
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          {data.map((contactData, idx) => (
            <ContactCard
              contactData={contactData}
              onDisable={() => disableHandler(contactData)}
              onEdit={() => editHandler(contactData)}
              isLast={data.length >= idx + 1}
              isEdit={isEdit}
              key={contactData.USERID}
            />
          ))}
        </ul>
      </main>
    </section>
  );
};

const ContactCard = ({
  onDisable = () => {},
  onEdit = () => {},
  contactData = {},
  isLast = false,
  isEdit = true,
}) => {
  const [isDisabled, setIsDisabled] = useState(contactData.FLG_STATUS === "U");

  return (
    <li
      key={contactData.USERID}
      style={{
        display: "inline-flex",
        width: "100%",
        flexDirection: "column",
        gap: 8,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 16,
          alignItems: "flex-start",
        }}
      >
        <div className="col-sm-11" style={{ flex: "1 0 0" }}>
          <div className="row form-group col-md-6">
            <div className="col-md-4 text-left">
              <label className="al-subtitle">{appLabel.contactName} </label>
            </div>
            <div className="col-md-7">
              <input
                type="text"
                className="form-control input-sm"
                defaultValue={`${contactData.USER_FIRSTNAME} ${contactData.USER_LASTNAME}`}
                disabled
              />
            </div>
          </div>
          <div className="row form-group col-md-6">
            <div className="col-md-4 text-left">
              <label className="al-subtitle">{appLabel.officePhone}</label>
            </div>
            <div className="col-md-7">
              <input
                type="text"
                className="form-control input-sm"
                defaultValue={contactData.USER_PHONENO}
                disabled
              />
            </div>
          </div>
          <div className="row form-group col-md-6">
            <div className="col-md-4 text-left">
              <label className="al-subtitle ">{appLabel.contactEmail} </label>
            </div>
            <div className="col-md-7">
              <input
                type="text"
                className="form-control input-sm"
                defaultValue={contactData.USERNAME}
                disabled
              />
            </div>
          </div>
        </div>
        {isEdit && (
          <footer
            style={{
              display: "flex",
              gap: 8,
            }}
          >
            <button
              style={{
                display: "inline-flex",
                gap: 4,
                alignItems: "center",
              }}
              className="btn btn-primary btn-sm"
              type="button"
              onClick={onEdit}
            >
              <i className="fa fa-edit" />
              <span>{appLabel.edit}</span>
            </button>
            <button
              onClick={() => {
                onDisable();
                setIsDisabled((prev) => !prev);
              }}
              type="button"
              className="btn btn-secondary btn-sm"
            >
              {isDisabled ? appLabel.enable : appLabel.disable}
            </button>
          </footer>
        )}
      </div>
      {!isLast && <div className="hr-line-dashed" style={{ marginTop: 0 }} />}
    </li>
  );
};

const AddOrEditContact = ({
  data,
  onSuccess,
  userData = {},
  contactCompanyId = "",
  onCancel,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm();
  const { toolTip } = appStatic;
  const { profileId, session, companyId } = userData;
  const [countryData, setCountryData] = useState([]);
  const [provinceData, setProvinceData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [subRoleData, setSubRoleData] = useState([]);
  const [passwordShown, setPasswordShown] = useState(false);

  const [cityId, setCityId] = useState("");
  const [roleId, setRoleId] = useState("");
  const [userDetail, setUserDetail] = useState({});

  useEffect(() => {
    // console.log(props);
    getCountry();
    getRole();
    // BOM.ActivateRightBtnAction("NewItemForm", "saveBtn", handleSubmit);
  }, []);

  useEffect(() => {
    if (!data) return;
    getDetailById();
  }, [data]);

  const getDetailById = () => {
    // console.log(params);

    BOM.LoadAlert(cnt.LOAD, "Processing");

    let body = {
      profileId,
      companyId: contactCompanyId,
      userId: data.USERID,
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, api.GetUser, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        let userDetail = res.userDetail;

        setUserDetail(userDetail);
        getProvince(userDetail.COUNTRY_ID);
        getCity(userDetail.PROVINCE_ID);
        getSubRole(userDetail.USER_PARENT_ROLE_ID);

        setValue("firstName", userDetail.USER_FIRSTNAME);
        setValue("lastName", userDetail.USER_LASTNAME);
        setValue("phoneNum", userDetail.USER_PHONENO);
        setValue("address", userDetail.ADDRESS);
        setValue("countryId", userDetail.COUNTRY_ID);
        setValue("provinceId", userDetail.PROVINCE_ID);
        setValue("cityId", userDetail.CITY_ID);
        setValue("roleId", userDetail.USER_ROLE_ID);
        setValue("parentRoleId", userDetail.USER_PARENT_ROLE_ID);
        setCityId(userDetail.CITY_ID);
        setRoleId(userDetail.USER_ROLE_ID);
      }
    });
  };
  const getCountry = () => {
    let body = {
      profileId,
      countryId: "",
      session,
    };

    BOM.FetchReqAction(body, api.GetCountry, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setCountryData(res.countryListing);
      }
    });
  };
  const getProvince = (countryId) => {
    console.log(countryId);
    let body = {
      profileId,
      countryId,
      session,
    };
    BOM.FetchReqAction(body, api.GetCountry, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setProvinceData(res.provinceListing);
      }
    });
  };

  const getCity = (stateId) => {
    // console.log("wow", stateId);
    let body = {
      profileId,
      stateId,
      session,
    };

    BOM.FetchReqAction(body, api.GetCity, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        //
        setCityData(res.cityListing);
      }
    });
  };

  function getRole() {
    BOM.LoadAlert(cnt.LOAD, "Processing");

    let body = {
      profileId,
      criteria: "A",
      roleId: "",
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, api.GetRole, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setRoleData(res.roleListing);
      }
    });
  }
  const getSubRole = (parentId) => {
    BOM.LoadAlert(cnt.LOAD, "Processing");

    let getSubRoleBody = {
      profileId,
      entityId: contactCompanyId,
      parentId,
      session,
    };

    /** fetch (reqBody, url, svc, callback) */
    BOM.FetchReqAction(getSubRoleBody, api.GetSubRole, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setSubRoleData(res.roleListing);
        // BOM.DatatableUsage();
      }
    });
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const formSubmit = (formValues) => {
    // console.log("data", formValues);
    BOM.LoadAlert(cnt.LOAD, "Processing");

    /**MAKE ADJUSTMENT FOR SOME DATA*/
    formValues.firstName = BOM.Uwfirst(formValues.firstName);
    formValues.lastName = BOM.Uwfirst(formValues.lastName);
    formValues.address = BOM.Uwfirst(formValues.address);
    formValues.lang = "ENG";
    if (data) formValues.userId = data.USERID;

    let body = {
      profileId,
      session,
      companyId: contactCompanyId,
      ...formValues,
    };

    // console.log(body);
    /** SEND REQ */

    BOM.FetchReqAction(
      body,
      data ? api.UpdateUser : api.CreateUser,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.message);
        } else {
          onSuccess({
            ...(data ? data : {}),
            USER_FIRSTNAME: formValues.firstName,
            USER_LASTNAME: formValues.lastName,
            USER_PHONENO: formValues.phoneNum,
            USERNAME: formValues.userName ?? data.USERNAME,
          });
          BOM.AlertMsg(cnt.SUCCESS, res.message);
        }
      }
    );
  };

  return (
    <section
      method="POST"
      id="NewItemForm1"
      autoComplete="off"
      style={{
        borderBottom: "1px dashed gray",
        paddingBottom: "24px",
      }}
    >
      <div className="ibox-content  panel-primary">
        <div className="row">
          <div className="col-sm-3">
            {/*left col*/}
            <div className="text-center">
              <img
                src="http://ssl.gstatic.com/accounts/ui/avatar_2x.png"
                className="avatar img-circle img-thumbnail"
                alt="avatar"
              />
            </div>
            <br />
          </div>
          {/*/col-3*/}
          <div className="col-sm-9">
            <ul className="nav nav-tabs">
              <li className="active">
                <a data-toggle="tab" href="#personalInfo" target="_self">
                  <i className="fa fa-user text-navy" />
                  &nbsp;Personal
                </a>
              </li>
              <li>
                <a data-toggle="tab" href="#contactInfo1" target="_self">
                  <i className="fa fa-wechat text-navy" />
                  &nbsp;Contact
                </a>
              </li>
              <li>
                <a data-toggle="tab" href="#addressInfo1" target="_self">
                  <i className="fa fa-home text-navy" />
                  &nbsp;Address
                </a>
              </li>
              <li>
                <a data-toggle="tab" href="#roleInfo" target="_self">
                  <i className="fa fa-tag text-navy" />
                  &nbsp;Role
                </a>
              </li>
            </ul>
            <div className="tab-content">
              <div className="tab-pane active" id="personalInfo">
                <div className="row" style={{ marginTop: 20 }}>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.firstName}&nbsp;
                      <Tooltips title={toolTip.firstName} />
                      <span className="asterisks">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control input-sm"
                      {...register("firstName", {
                        required: "First Name is required !",
                        minLength: {
                          value: 3,
                          message: "Name should be greater than 3 characters",
                        },
                      })}
                      placeholder={appLabel.firstName}
                    />
                    <span className="asterisks">
                      {errors?.firstName?.message}
                    </span>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.lastName}&nbsp;
                      <Tooltips title={toolTip.lastName} />
                      <span className="asterisks">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control input-sm"
                      {...register("lastName", {
                        required: "Last Name is required !",
                        minLength: {
                          value: 3,
                          message: "Name should be greater than 3 characters",
                        },
                      })}
                      placeholder={appLabel.lastName}
                    />
                    <span className="asterisks">
                      {errors?.lastName?.message}
                    </span>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.userName}&nbsp;
                      <Tooltips title={toolTip.userName} />
                      <span className="asterisks">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control input-sm"
                      {...(data
                        ? {
                            defaultValue: userDetail.USERNAME,
                            disabled: true,
                          }
                        : {
                            ...register("userName", {
                              required: "Username is required !",
                              pattern: {
                                value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                                message:
                                  "Email must be a valid email address !",
                              },
                              minLength: {
                                value: 3,
                                message:
                                  "Userame should be greater than 3 characters !",
                              },
                            }),
                          })}
                      placeholder={appLabel.userName}
                    />
                    <span className="asterisks">
                      {errors?.userName?.message}
                    </span>
                  </div>
                  {!data && (
                    <div className="form-group col-md-6">
                      <label className="al-subtitle">
                        {appLabel.userPassword}&nbsp;
                        <Tooltips title={toolTip.userPassword} />
                        <span className="asterisks">*</span>
                      </label>
                      <input
                        type={passwordShown ? "text" : "password"}
                        className="form-control input-sm"
                        {...register("userPswd", {
                          required: "Password is required !",
                          minLength: {
                            value: 3,
                            message:
                              "Password should be greater than 5 characters !",
                          },
                        })}
                        placeholder={appLabel.userPassword}
                      />
                      <span
                        className="p-viewer"
                        onClick={() => togglePassword()}
                      >
                        <i
                          className={
                            passwordShown ? "fa fa-eye-slash" : "fa fa-eye"
                          }
                        ></i>
                      </span>
                      <span className="asterisks">
                        {errors?.userPswd?.message}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="tab-pane" id="contactInfo1">
                <div className="row" style={{ marginTop: 20 }}>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.userEmail}&nbsp;
                      <Tooltips title={toolTip.userEmail} />
                      <span className="asterisks">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control input-sm"
                      placeholder={appLabel.username}
                      {...(data
                        ? {
                            defaultValue: userDetail.USERNAME,
                            disabled: true,
                          }
                        : {
                            ...register("userEmail", {
                              required: "Email is required!",
                              pattern: {
                                value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                                message: "Email must be a valid email address",
                              },
                            }),
                          })}
                    />
                    <span className="asterisks">
                      {errors?.userEmail?.message}
                    </span>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.userPhone}&nbsp;
                      <Tooltips title={toolTip.userPhone} />
                      <span className="asterisks">*</span>
                    </label>
                    <input
                      type="number"
                      min={0}
                      className="form-control input-sm"
                      {...register("phoneNum", {
                        required: "Phone Number is required",
                        minLength: {
                          value: 10,
                          message:
                            "Phone Number should be greater than 9 digits",
                        },
                        maxLength: {
                          value: 15,
                          message: "Phone Number should be less than 16 digits",
                        },
                      })}
                      placeholder={appLabel.userPhone}
                    />
                    <span className="asterisks">
                      {errors?.phoneNum?.message}
                    </span>
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="addressInfo1">
                <div className="row" style={{ marginTop: 20 }}>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.country}&nbsp;
                      <Tooltips title={toolTip.userCountry} />
                      <span className="asterisks">*</span>
                    </label>

                    <select
                      className="form-control input-sm"
                      {...(data
                        ? {
                            value: getValues("countryId"),
                          }
                        : {})}
                      {...register("countryId", {
                        required: "Country is required !",
                        onChange: (e) => getProvince(e.target.value),
                      })}
                    >
                      <option value="">{appLabel.choose}</option>
                      {countryData.map((item, index) => (
                        <option value={item.ID} key={index}>
                          {item.COUNTRY_NAME}
                        </option>
                      ))}
                    </select>
                    <span className="asterisks">
                      {errors?.countryId?.message}
                    </span>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.province}&nbsp;
                      <Tooltips title={toolTip.userProvince} />
                      <span className="asterisks">*</span>
                    </label>
                    <select
                      className="form-control input-sm"
                      {...(data ? { value: getValues("provinceId") } : {})}
                      {...register("provinceId", {
                        required: "Province/State is required !",
                        onChange: (e) => getCity(e.target.value),
                      })}
                    >
                      <option value="">{appLabel.choose}</option>
                      {provinceData.map((item, index) => (
                        <option value={item.ID} key={index}>
                          {item.PROVINCE_NAME}
                        </option>
                      ))}
                    </select>
                    <span className="asterisks">
                      {errors?.provinceId?.message}
                    </span>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.city}&nbsp;
                      <Tooltips title={toolTip.userCity} />
                      <span className="asterisks">*</span>
                    </label>
                    <select
                      className="form-control input-sm"
                      {...(data
                        ? {
                            value: cityId,
                            ...register("cityId", {
                              required: "Field is required.",
                              onChange: (e) => setCityId(e.target.value),
                            }),
                          }
                        : {
                            ...register("cityId", {
                              required: "City is required !",
                            }),
                          })}
                    >
                      <option value="">{appLabel.choose}</option>
                      {cityData.map((item, index) => (
                        <option value={item.ID} key={index}>
                          {item.CITY_NAME}
                        </option>
                      ))}
                    </select>
                    <span className="asterisks">{errors?.cityId?.message}</span>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.address}&nbsp;
                      <Tooltips title={toolTip.userAddress} />
                      <span className="asterisks">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control input-sm"
                      {...register("address", {
                        required: "Address is required !",
                        minLength: {
                          value: 3,
                          message:
                            "Address should be greater than 3 characters",
                        },
                      })}
                      placeholder={appLabel.address}
                    />
                    <span className="asterisks">
                      {errors?.address?.message}
                    </span>
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="roleInfo">
                <div className="row" style={{ marginTop: 20 }}>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.parentRoleName}&nbsp;
                      <Tooltips title={toolTip.parentRoleName} />
                      <span className="asterisks">*</span>
                    </label>
                    <select
                      className="form-control input-sm"
                      {...(data ? { value: getValues("parentRoleId") } : {})}
                      {...register("parentRoleId", {
                        required: "Choose a parent role !",
                        onChange: (e) => getSubRole(e.target.value),
                      })}
                    >
                      <option value="">{appLabel.choose}</option>
                      {roleData.map((item, index) => (
                        <option value={item.ROLE_ID} key={index}>
                          {item.ROLE_DESCRIPTION}
                        </option>
                      ))}
                    </select>
                    <span className="asterisks">
                      {errors?.parentRoleId?.message}
                    </span>
                  </div>
                  <div className="form-group col-md-6">
                    <label className="al-subtitle">
                      {appLabel.roleName}&nbsp;
                      <Tooltips title={toolTip.roleName} />
                      <span className="asterisks">*</span>
                    </label>
                    <select
                      className="form-control input-sm"
                      {...(data
                        ? {
                            value: roleId,
                            ...register("roleId", {
                              required: "Field is required.",
                              onChange: (e) => setRoleId(e.target.value),
                            }),
                          }
                        : {
                            ...register("roleId", {
                              required: "Role Name is required !",
                            }),
                          })}
                    >
                      <option value="">{appLabel.choose}</option>
                      {subRoleData.map((item, index) => (
                        <option value={item.ROLE_ID} key={index}>
                          {item.ROLE_NAME}
                        </option>
                      ))}
                    </select>
                    <span className="asterisks">{errors?.roleId?.message}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*/tab-content*/}
        </div>
      </div>
      <footer
        style={{
          display: "flex",
          justifyContent: "end",
          width: "100%",
          gap: 16,
        }}
        className="w-full"
      >
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          {appLabel.cancelBtn}
        </button>
        <button
          onClick={handleSubmit(formSubmit, BOM.onError)}
          type="button"
          className="btn btn-primary"
        >
          {data ? appLabel.update : appLabel.create}
        </button>
      </footer>
    </section>
  );
};

export default OtherContacts;
